<template>
  <div>
    <h3>{{ title }}</h3>

    <b-card-group class="checkout-card-group mb-3">
      <slot />
    </b-card-group>
  </div>
</template>

<script>
export default {
  name: 'BaseCheckoutCardGroup',
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
@media (max-width: 767.98px) {
  .checkout-card-group {
    flex-direction: column;
  }

  .checkout-card-group > .card {
    border-radius: 0.25rem;
    margin-bottom: 0.75rem;
  }

  .checkout-card-group > .card:last-child {
    margin-bottom: 0;
  }
}
</style>
